import React, {useContext, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import {  useNavigate } from "react-router-dom";
import "./Login.css";

const Login = () => { 

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    const response = await login(email, password);
    
    if (response.success) {
      alert("Login successful!");
      navigate("/dashboard"); // Redirect to dashboard
    } else {
      alert(response.message);
    }
  };
 
  

  return (
   <div className="login-container">
      <div className="login-box">
        <h2 className="login-title">USER LOGIN</h2>
        <form onSubmit={handleLogin} className="form">
        <div className="input-group">
          <span className="icon">👤</span>
          <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required className="input-field" />
        </div>
        <div className="input-group">
          <span className="icon">🔒</span>
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
           className="input-field" />
        </div>
        <button type="submit" className="login-button">Login</button>
        </form>
      </div>
    </div>
  );
};
export default Login;


